var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.widgetComponent)?_c('v-col',{staticClass:"widget-col",attrs:{"cols":"12","sm":_vm.widget.type === 'suggestion' ? 6 : 12}},[_c(_vm.widgetComponent,_vm._g({tag:"component",attrs:{"data":_vm.widget.data}},_vm.$listeners))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }